/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly favorites?: {
        readonly " $fragmentRefs": FragmentRefs<"FollowSearchButton_favoritesConnection">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user" | "PdpSharedMakeOfferButton_user">;
    readonly " $refType": "PdpRespSidebarButtons_user";
};
export type PdpRespSidebarButtons_user$data = PdpRespSidebarButtons_user;
export type PdpRespSidebarButtons_user$key = {
    readonly " $data"?: PdpRespSidebarButtons_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarButtons_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "fetchFollowSearch",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchFollowSearch",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favorites",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "pages",
              "variableName": "followSearchPages"
            },
            {
              "kind": "Literal",
              "name": "types",
              "value": [
                "SEARCH"
              ]
            }
          ],
          "concreteType": "favoritesConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FollowSearchButton_favoritesConnection",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '32bd960a58c5b1c86e89a1e0cf46765a';
export default node;
